/** Catálogos Step Workspace — alineados SPEC-01 / HubSpot SPEC-20. */

export const SECTOR_IPA_OPTIONS = [
  "Distribución",
  "Manufactura",
  "Retail",
  "Logística",
  "Agro",
  "Servicios profesionales",
  "Otro",
];

export const DEFAULT_SECTOR_IPA = SECTOR_IPA_OPTIONS[5]; // Servicios profesionales

export const EMPLOYEE_COUNT_OPTIONS = [
  { value: "<10", label: "Menos de 10" },
  { value: "10-50", label: "10–50" },
  { value: "51-200", label: "51–200" },
  { value: "201-500", label: "201–500" },
  { value: "500+", label: "Más de 500" },
];

export const DEFAULT_EMPLOYEE_COUNT = EMPLOYEE_COUNT_OPTIONS[0].value;
